export default __webpack_public_path__ + "static/uoft-logo-white-f071eeb105ce4ee1fea87e7bb04df7c5.svg";